export const MANAGEMENT_DASHBOARD_EVENT = "Management Dashboard";
export const MANAGEMENT_DASHBOARD_STEPS = {
  ENTRY: "Entry",
  MAP_LOADED: "Map Loaded",
  SEARCH_ATTEMPTED: "Search Attempted",
  SEARCH_SUCCESS: "Search Success"
};
